import { render, staticRenderFns } from "./BulkModeRunnitBoardMembersManagement.vue?vue&type=template&id=2367f5ff&scoped=true"
import script from "./BulkModeRunnitBoardMembersManagement.vue?vue&type=script&lang=ts"
export * from "./BulkModeRunnitBoardMembersManagement.vue?vue&type=script&lang=ts"
import style0 from "./BulkModeRunnitBoardMembersManagement.vue?vue&type=style&index=0&id=2367f5ff&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2367f5ff",
  null
  
)

export default component.exports